import serviceToCalculateGenerator from '@pages/AdditionalServices/containers/services/serviceToCalculateGenerator';
import { AdditionServicesState } from '@pages/AdditionalServices/containers/types';
import { ServicePriceCalculationItemsProps } from '@services/requests/servicesService/servicesServicesService/interface';

/**
 * Параметры расчета всех услуг варианта, включая дополнительные
 */
export const getVariantServicesToCalculate = (
  state: AdditionServicesState,
  variantId: string
): ServicePriceCalculationItemsProps[] =>
  state.VariantServices[variantId]
    .map((s) => [s, ...s.additionServices])
    .flat(1)
    .map((s) =>
      serviceToCalculateGenerator().Generate(
        s,
        state.CurrencyID,
        state.FieldValues,
        state.VariantFieldValues[variantId],
        state.ServiceTemplateStore[variantId][s.id]
      )
    )
    .flat(1);
